import React from 'react';
import { Globe, ExternalLink } from 'lucide-react';
import styles from './base-item-card.module.css';

interface ItemCardFooterProps {
  websiteUrl?: string;
  activityType?: string;
  onBookTourClick?: () => void;
}

export const ItemCardFooter: React.FC<ItemCardFooterProps> = ({
  websiteUrl,
  activityType,
  onBookTourClick
}) => {
  console.log('[ItemCardFooter] RENDERED - websiteUrl:', websiteUrl);

  // Determine action button text based on activity type
  const getActionText = () => {
    if (!activityType) return null;

    const type = activityType.toLowerCase();

    // Food & Drink related types
    if (
      type.includes('food') ||
      type.includes('drink') ||
      type.includes('restaurant') ||
      type.includes('cafe') ||
      type.includes('bar') ||
      type.includes('dining')
    ) {
      return 'Make Reservations';
    }

    // Accommodation types
    if (
      type.includes('hotel') ||
      type.includes('resort') ||
      type.includes('accommodation') ||
      type.includes('lodging')
    ) {
      return 'Make Reservations';
    }

    // Tour/Activity types
    if (
      type.includes('place') ||
      type.includes('country') ||
      type.includes('city') ||
      type.includes('destination') ||
      type.includes('tour') ||
      type.includes('activity') ||
      type.includes('attraction') ||
      type.includes('museum') ||
      type.includes('park')
    ) {
      return 'Book Tour';
    }

    return null;
  };

  const actionText = getActionText();
  const isBookTourAction = actionText === 'Book Tour';

  // Don't render if there's no website URL and no action button
  if (!websiteUrl && !actionText) {
    return <div className={styles.cardFooter} />;
  }

  return (
    <div className={styles.cardFooter}>
      {/* Left section: Website link */}
      <div className={styles.footerLeft}>
        {websiteUrl && (
          <a
            href={websiteUrl}
            target='_blank'
            rel='noopener noreferrer'
            onClick={(e) => e.stopPropagation()}
            className={styles.footerLink}
            title='Visit website'
          >
            <Globe size={16} />
            <span>Visit website</span>
          </a>
        )}
      </div>

      {/* Right section: Action button */}
      <div className={styles.footerRight}>
        {isBookTourAction && onBookTourClick && (
          <button
            type='button'
            onClick={(e) => {
              e.stopPropagation();
              onBookTourClick();
            }}
            className={styles.footerAction}
            style={{ border: 'none', cursor: 'pointer' }}
          >
            {actionText}
          </button>
        )}

        {!isBookTourAction && actionText && websiteUrl && (
          <a
            href={websiteUrl}
            target='_blank'
            rel='noopener noreferrer'
            onClick={(e) => e.stopPropagation()}
            className={styles.footerAction}
          >
            {actionText}
            <ExternalLink size={14} />
          </a>
        )}
      </div>
    </div>
  );
};
